import { Link, createFileRoute } from '@tanstack/react-router'
import { useMe, useOpenGate, useSpots, useStatus } from '@api/generated'
import { BookingCalendar } from '@components/BookingCalendar'
import { PageSpinner } from '@components/PageSpinner'
import { errorMessage } from '@utils/errors'

export const Route = createFileRoute('/')({ component: ParkingSpot })

function ParkingSpot() {
  return (
    <div className="px-4 sm:px-8 space-y-4 sm:space-y-6 max-w-5xl">
      <h1 className="text-2xl sm:text-3xl font-bold">Parkplatz</h1>
      <GateButton />
      <SpotStatus />
      <BookingCalendar />
    </div>
  )
}

function GateButton() {
  const status = useStatus()
  const open = useOpenGate()
  if (!status.data?.gate) return null
  return (
    <div className="flex flex-wrap items-center gap-3">
      <button
        className="btn btn-primary btn-lg w-full sm:btn-md sm:w-auto"
        disabled={open.isPending}
        onClick={() => open.mutate()}
      >
        {open.isPending && <span className="loading loading-spinner" />}
        Tor DA-FP8 (DACHPC Tiefgarage) öffnen
      </button>
      {open.isSuccess && (
        <span className="text-success">Das Tor sollte sich jetzt öffnen.</span>
      )}
      {open.isError && (
        <span role="alert" className="text-error">
          {errorMessage(open.error)}
        </span>
      )}
    </div>
  )
}

function SpotStatus() {
  const spots = useSpots({ query: { refetchInterval: 30_000 } })
  const me = useMe()
  if (spots.isPending) return <PageSpinner inline />
  if (spots.isError) {
    return (
      <div role="alert" className="alert alert-error">
        {errorMessage(spots.error)}
      </div>
    )
  }
  if (spots.data.length === 0) {
    return (
      <div role="alert" className="alert alert-warning">
        <span>
          Es wurde noch kein Stellplatz eingerichtet.{' '}
          {me.data?.admin ? (
            <Link to="/admin" className="link">
              Auf der Administrationsseite einrichten.
            </Link>
          ) : (
            'Bitte einen Administrator fragen.'
          )}
        </span>
      </div>
    )
  }
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {spots.data.map((s) => (
        <div key={s.id} className="card bg-base-200 shadow-sm">
          <div className="card-body gap-1 p-4">
            <div className="text-sm font-bold">{s.label}</div>
            {s.state === 'booking' ? (
              <>
                <div className="text-2xl font-bold tracking-wide">
                  {s.plate}
                </div>
                <div className="text-xs opacity-70">{s.note}</div>
              </>
            ) : (
              <div className="text-lg font-bold opacity-80">
                Frei
                {s.plate && (
                  <span className="text-xs font-normal opacity-60">
                    {' '}
                    (geparktes Kennzeichen: {s.plate})
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
